import { render, staticRenderFns } from "./InfoHr.vue?vue&type=template&id=05b40fd9&scoped=true&"
import script from "./InfoHr.vue?vue&type=script&lang=js&"
export * from "./InfoHr.vue?vue&type=script&lang=js&"
import style0 from "./InfoHr.vue?vue&type=style&index=0&id=05b40fd9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b40fd9",
  null
  
)

export default component.exports